export const randomString = (len = 6) =>
  Math.random().toString(36).substring(len);
